// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f0-n","top":"styles_top__2bp3D"};